export default __webpack_public_path__ + "static/media/img-09.8e757592.png";